import { useOktaAuth } from "@okta/okta-react";

const SecureComponent = (props) => {
  const { authState } = useOktaAuth();
  const { children } = props;
  return authState?.isAuthenticated ? children : null;
};

export default SecureComponent;
